import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiList-padding': {
      padding: '1rem'
    }
  },

  control: {
    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: theme.size.lg
    }
  },

  radio: {
    marginTop: '1px'
  },

  controlLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: theme.size.sm,
      textAlign: 'center'
    }
  },

  controlLabelBold: {
    '& .MuiFormControlLabel-label': {}
  }
}))

export default useStyles
